import { PackagingUnitDto } from '../../packaging-unit-entities/packaging-unit-dto';
import { RecyclabilityResultDto } from '../recyclability-result-dto';
import { ComponentRecyclabilityResultDto } from './component-recyclability-result-dto';

export class PackagingUnitRecyclabilityResultDto extends RecyclabilityResultDto {
  analyzedPackagingUnit!: PackagingUnitDto;
  componentResults!: ComponentRecyclabilityResultDto[];
}